import { render, staticRenderFns } from "./UnsubscribeNotification.vue?vue&type=template&id=30ce10bb&"
import script from "./UnsubscribeNotification.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports